import { IconProps } from "./IconType";

export const Edit = ({ className }: IconProps) => (
  <svg className={className} width='25' height='25' viewBox='0 0 25 25' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M15.1489 4.80518L0.945495 19.0085L0.15332 24.5314L5.67623 23.7393L19.8796 9.53591L15.1489 4.80518Z' fill='black'/>
    <path d='M20.665 0.85805L23.8208 4.01381V4.01372C24.03 4.22301 24.1476 4.50683 24.1476 4.80266C24.1476 5.0986 24.03 5.3824 23.8208 5.5916L21.4539 7.95853L16.7202 3.22489L19.0871 0.857963V0.85805C19.2964 0.648762 19.5802 0.53125 19.8761 0.53125C20.172 0.53125 20.4558 0.648751 20.665 0.85805Z' fill='black'/>
  </svg>
);